import clsx from 'clsx'

import type { CarouselControlProps } from './type'

import { ChevronLeftFilledIcon } from '@/components/icons/ChevronLeftFilled'
import { ChevronRightOutlinedIcon } from '@/components/icons/ChevronRightOutlined'

import { Icon } from '../../icon'

export const CarouselControl = ({
  isPrev = false,
  onClick,
}: CarouselControlProps) => {
  return (
    <button
      className={clsx('tw-w-8', 'tw-flex tw-items-center tw-justify-center')}
      onClick={onClick}
    >
      {isPrev ? (
        <Icon icon={ChevronLeftFilledIcon} size={'2xl'} color={'description'} />
      ) : (
        <Icon
          icon={ChevronRightOutlinedIcon}
          size={'2xl'}
          color={'description'}
        />
      )}
    </button>
  )
}
